// extracted by mini-css-extract-plugin
module.exports = {"portal":"portal_provider_portal__0EjaI","portal__scrollable":"portal_provider_portal__scrollable__fkiPi"};